import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appValueChangeHighlight]'
})
export class ValueChangeHighlightDirective implements OnChanges, OnDestroy {
  @Input() appValueChangeHighlight: number | string;
  @Input() highlightDuration: number = 2000;

  private previousValue: number | string | null = null;
  private highlightClass = 'value-changed-highlight';
  private timeoutId: number | null = null;

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appValueChangeHighlight'] && !changes['appValueChangeHighlight'].firstChange) {
      const currentValue = changes['appValueChangeHighlight'].currentValue;
      const previousValue = changes['appValueChangeHighlight'].previousValue;

      if (currentValue !== previousValue && previousValue !== null && previousValue !== undefined) {
        this.applyHighlight();
      }
    }

    if (changes['appValueChangeHighlight']?.firstChange) {
      this.previousValue = changes['appValueChangeHighlight'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.clearTimeout();
  }

  private applyHighlight(): void {
    this.clearTimeout();
    this.renderer.addClass(this.el.nativeElement, this.highlightClass);

    this.timeoutId = window.setTimeout(() => {
      this.renderer.removeClass(this.el.nativeElement, this.highlightClass);
      this.timeoutId = null;
    }, this.highlightDuration);
  }

  private clearTimeout(): void {
    if (this.timeoutId !== null) {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
}

